import { render, staticRenderFns } from "./perinfdiolg.vue?vue&type=template&id=18a52d63&scoped=true&"
import script from "./perinfdiolg.vue?vue&type=script&lang=js&"
export * from "./perinfdiolg.vue?vue&type=script&lang=js&"
import style0 from "./perinfdiolg.vue?vue&type=style&index=0&id=18a52d63&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a52d63",
  null
  
)

export default component.exports